import request from '@/utils/request'

// 查询商品产品分类信息1)业务定义：商品产品分类 列表
export function listType(query) {
  return request({
    url: '/server/type/list',
    method: 'get',
    params: query
  })
}

// 查询商品产品分类信息1)业务定义：商品产品分类 详细
export function getType(typeId) {
  return request({
    url: '/server/type/' + typeId,
    method: 'get'
  })
}

// 新增商品产品分类信息1)业务定义：商品产品分类
export function addType(data) {
  return request({
    url: '/server/type',
    method: 'post',
    data: data
  })
}

// 修改商品产品分类信息1)业务定义：商品产品分类
export function updateType(data) {
  return request({
    url: '/server/type',
    method: 'put',
    data: data
  })
}

// 删除商品产品分类信息1)业务定义：商品产品分类
export function delType(typeId) {
  return request({
    url: '/server/type/' + typeId,
    method: 'delete'
  })
}

// 导出商品产品分类信息1)业务定义：商品产品分类
export function exportType(query) {
  return request({
    url: '/server/type/export',
    method: 'get',
    params: query
  })
}


//适合MAP的树
export function loadDataMap(){
    return request({
        url: '/goods/sCommType/getInputTree',
        method: 'get',
    })
}

//商品分类树
export function getClickTree(){
    return request({
        url: '/goods/sCommType/getClickTree',
        method: 'get',
    })
}
